import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { connect } from "react-redux";
import { defaultAction } from "@actions/defaultAction";
import { deleteACH } from "@actions/paymentMethods";

import { SET_OPEN_REMOVE_BANK_ACCT_MODAL } from "@constants/achActionTypes";
import styled from "@emotion/styled";
import CustomSubmitButton from "./CustomSubmitButton";

const customStyles = {
  overlay: {
    backgroundColor: "rgba(31, 32, 33, 0.9)"
  }
};
const ButtonDiv = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  grid-gap: 25px;
  margin-top: 43px;
  @media (max-width: 600px) {
    margin-top: 30px;
  }
  @media (max-width: 550px) {
    width: 85%;
    margin: 0 auto;
    margin-top: 24px;
  }
  @media (max-width: 500px) {
    margin-bottom: 20px;
  }
`;
const RemoveBankAccountModal = ({
  closeRemoveBankAccountModal,
  bankAccountToRemove,
  deleteACH,
  open
}) => {
  const [removeText, setRemoveText] = useState("Remove");
  const [removeButton, setRemoveButton] = useState("ORANGE_BUTTON");
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (open) {
      setLoading(false);
    }
  }, [open]);

  const removeBankAccount = async () => {
    if (loading) return;
    setLoading(true);
    const response = await deleteACH(bankAccountToRemove);
    if (response === "success") {
      setRemoveText("Success");
      setRemoveButton("GREEN_BUTTON");
      setTimeout(() => {
        setRemoveText("Remove");
        setRemoveButton("ORANGE_BUTTON");
        closeRemoveBankAccountModal();
      }, 1000);
    } else {
      setLoading(false);
    }
  };
  return (
    <Modal
      className="Modal__Bootstrap modal-dialog remove-bank-account"
      closeTimeoutMS={150}
      isOpen={open}
      contentLabel="Support"
      style={customStyles}
    >
      <div className="modal-content modal-content-padding">
        <div className="modal-header mar-t-5">
          <div className="acct-modal-close-btn">
            <img
              src="https://cdn.cardcash.com/website/ui/elements/close.svg"
              className="fa fa-times"
              aria-hidden="true"
              onClick={closeRemoveBankAccountModal}
              alt="close button"
            />
          </div>
          <div className="acct-modal-heading">Remove Account</div>
        </div>
        <div
          className="modal-body modal-body-padding"
          style={{ fontSize: "14px" }}
        >
          <div className="acct-modal-text">
            Are you sure you want to remove this account?
          </div>
          <div>
            <ButtonDiv>
              <CustomSubmitButton
                styles={{ height: "72px", borderRadius: "36px" }}
                action={() => {
                  removeBankAccount();
                }}
                buttonType={removeButton}
                className={"remove-cc-modal-button"}
              >
                {removeText}
              </CustomSubmitButton>
              <CustomSubmitButton
                styles={{ height: "72px", borderRadius: "36px" }}
                action={closeRemoveBankAccountModal}
                buttonType={"WHITE_BUTTON_ORANGE_COLOR"}
                className={"remove-cc-modal-button"}
              >
                Close
              </CustomSubmitButton>
            </ButtonDiv>
          </div>
        </div>
      </div>
    </Modal>
  );
};
export default connect(
  state => ({
    open: state.ach.showRemoveBankAccountModal,
    bankAccountToRemove: state.ach.bankAccountToRemove
  }),
  dispatch => ({
    closeRemoveBankAccountModal: () =>
      dispatch(defaultAction(SET_OPEN_REMOVE_BANK_ACCT_MODAL, false)),
    deleteACH: bankAccount => dispatch(deleteACH(bankAccount))
  })
)(RemoveBankAccountModal);
